define('orb/features/_cookieprompt', ['orb/cookies', 'orb/lib/_script', 'orb/nav', 'orb/fig'], function (bbccookies, script, nav, orbFig) {
    function addCookieBanner(cookiePromptTemplate) {
        var parsedHTML = cookiePromptTemplate.replace(/<<bbcBaseUrl>>/g, window.orb.bbcBaseUrl);
        document.getElementById('cookiePrompt').innerHTML = parsedHTML;
    }

    function loadCookieBanner(fig) {
        var isUK = !!fig.geo.isUK(),
            isEU = !!fig.geo.isEU(),
            url = window.orb.staticHost + "/cookie-prompt/" + window.orb.lang;

        if (isEU) {
            if (isUK) {
                url += ".js";
            } else {
                url += "-nonuk-eu.js";
            }
            script.jsonp(url, addCookieBanner, { callbackName: "cookiePrompt" });
            bbccookies.setDefaultCookiesSingleDomain();
        }
    }

    function initCookiePrompt() {
        if (bbccookies.cookiesEnabled() && !bbccookies.isCookiePolicySet()) {
            var cssUrl = window.orb.staticHost + "/css/bbccookies.min.css";
            nav.loadCss(cssUrl, function () {
                orbFig.load(loadCookieBanner, loadCookieBanner);
            });
        }
    }

    return initCookiePrompt;
});
